module.exports = __webpack_public_path__ + "img/baby_4.2c909b13.jpg";